module.exports = __webpack_public_path__ + "zvetseni-prsou_40_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-prsou_40_after.jpg
// module id = 1333
// module chunks = 0